import React from 'react';

const items = [
  'Lead Generation',
  'Sales Funnels',
  'AI Automation',
  'CRM Systems',
  'Web Development',
  'Performance Marketing',
  'Revenue Scaling',
  'Paid Ads',
];

const Marquee = () => {
  // Duplicate for seamless loop
  const doubled = [...items, ...items];

  return (
    <div
      className="overflow-hidden border-t border-b border-white/5 py-4"
      style={{ background: 'rgba(0,123,255,0.03)' }}
      aria-hidden="true"
    >
      <style>{`
        @keyframes marquee {
          from { transform: translateX(0); }
          to   { transform: translateX(-50%); }
        }
        .marquee-track {
          display: flex;
          gap: 3rem;
          white-space: nowrap;
          animation: marquee 22s linear infinite;
        }
        .marquee-track:hover {
          animation-play-state: paused;
        }
      `}</style>
      <div className="marquee-track">
        {doubled.map((item, i) => (
          <span
            key={i}
            className="inline-flex items-center gap-3 text-xs font-bold uppercase tracking-[0.15em] text-white/30"
          >
            <span className="text-[#007bff] text-[8px]">◆</span>
            {item}
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
